var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgListSharp = function SvgListSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 4.2H3.2V5.8H4.8V4.2ZM4.8 11.2H3.2V12.8H4.8V11.2ZM4.8 18.2H3.2V19.8H4.8V18.2ZM20.8 4.2H9.2V5.8H20.8V4.2ZM20.8 11.2H9.2V12.8H20.8V11.2ZM20.8 18.2H9.2V19.8H20.8V18.2ZM2 3V7H6V3H2ZM2 10V14H6V10H2ZM6 17V21H2V17H6ZM8 3V7H22V3H8ZM22 10V14H8V10H22ZM8 17V21H22V17H8Z"
  })));
};
export default SvgListSharp;